module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-ties.fc96eba0.png";